import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import RelevanceIcon from "../../atoms/relevence-icon";
import { SORT_OPTIONS } from "../../../constants";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

import "./relevance-dropdown.m.css";

const RelevanceDropdown = ({ onSortChange, currentSort = "score" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    } else {
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (value) => {
    onSortChange(value);
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const currentOption = SORT_OPTIONS.find(option => option.value === currentSort);

  return (
    <div styleName="relevance-dropdown" ref={dropdownRef}>
      <button 
        styleName={`relevance-button ${isOpen ? 'active' : ''}`}
        onClick={handleToggle}
      >
        <RelevanceIcon />
        <span>{currentOption?.label || "Relevance"}</span>
      </button>
      
      {isOpen && (
       <>
        <div styleName="dropdown-wrapper" />
          <div styleName="dropdown-backdrop" onClick={handleToggle}></div>
          <div styleName="dropdown-menu">
            <div styleName="dropdown-header">
              <h3 styleName="dropdown-title">Sort by</h3>
              <button styleName="close-button" onClick={handleToggle}>
                <SvgIconHandler type="close" width="12" height="12" />
              </button>
            </div>
            <div styleName="dropdown-options">
              {SORT_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  styleName={`dropdown-option ${currentSort === option.value ? 'selected' : ''}`}
                  onClick={() => handleOptionClick(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
        </div>
        </>
      )}
    </div>
  );
};

RelevanceDropdown.propTypes = {
  onSortChange: PropTypes.func.isRequired,
  currentSort: PropTypes.string
};

export { RelevanceDropdown };
